module.exports = __webpack_public_path__ + "static/media/signup.c326ba10.png";